import { normalizeString } from './string-utils'
import { isNullish } from './type-utils'

export const fuzzyMatch = (indexedValue: string, searchQuery: string): boolean => {
  if (isNullish(indexedValue) || indexedValue === '' || isNullish(searchQuery) || searchQuery === '') return false // special case
  return normalizeString(isNullish(indexedValue) ? '' : indexedValue).includes(normalizeString(searchQuery))
}
